<div style="display: flex; align-items: flex-start;">

    <!-- Field -->
    <tyl-form-field [ngStyle]="{'width': width}"
        [label]="label"
        [hintLabel]="customHint ? customHint : (twelveHourFormat ? 'hh:mm am/pm' : 'HH:mm')">
        <input matInput
            #timeField
            [required]="required"
            [disabled]="disabled"
            [id]="id"
            [name]="name"
            [(ngModel)]="timeValue"
            (blur)="change24HoursTo12Hours == true && onBlur()"
            [pattern]="useValidator ? (twelveHourFormat ? twelveHourRegexp : twentyFourHourRegexp) : null"
            [textMask]="{mask: (twelveHourFormat ? twelveHourTimeMask : twentyFourHourTimeMask), guide: true}" />
    </tyl-form-field>

    <!-- Now Button -->
    <tyl-button *ngIf="showNowButton"
        style="padding-top: 11px;"
        image="clock with checkmark.png"
        disabledImage="clock with checkmark disabled.png"
        [disabled]="disabled"
        (clickEvent)="nowClick()"></tyl-button>
</div>
